import { render, staticRenderFns } from "./BcDatePicker.vue?vue&type=template&id=03f520fe"
import script from "./BcDatePicker.vue?vue&type=script&lang=js"
export * from "./BcDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports